import React, { useState } from "react";
import { Trophy, Copy, Check } from "lucide-react";
import { Button } from "./ui/button";
import { REF_CODE, ROOBET_LINK } from "../mock";

const Hero = () => {
  const [copied, setCopied] = useState(false);

  const copyCode = () => {
    navigator.clipboard?.writeText(REF_CODE);
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden pt-32 pb-20 bg-[#2f2753]">
      <div className="relative z-10 max-w-4xl mx-auto px-5 text-center flex flex-col items-center">
        {/* mascot above the title */}
        <img
          src="/assets/broer-logo.png"
          alt="Broer mascot"
          className="h-32 w-32 md:h-44 md:w-44 rounded-full object-cover ring-4 ring-[#edbb23] mb-6 animate-float-slow"
        />

        <p className="text-[#edbb23] font-extrabold tracking-[0.35em] text-sm md:text-base mb-3 animate-fade-up">
          WELCOME TO
        </p>

        <h1 className="text-white text-7xl md:text-9xl font-black tracking-tighter leading-none animate-fade-up" style={{ animationDelay: "0.1s" }}>
          BROER
        </h1>

        <p className="mt-8 text-lg md:text-xl text-[#b7b0d6] max-w-xl mx-auto animate-fade-up" style={{ animationDelay: "0.2s" }}>
          Elevating your gambling experience with our customized reward system and monthly wager races.
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4 animate-fade-up" style={{ animationDelay: "0.3s" }}>
          <Button
            onClick={() => scrollTo("#leaderboard")}
            className="bg-[#edbb23] hover:bg-[#f4cf52] text-[#251e44] font-extrabold rounded-xl px-8 h-14 text-base"
          >
            <Trophy size={18} className="mr-2" /> LEADERBOARD
          </Button>
          <a href={ROOBET_LINK} target="_blank" rel="noopener noreferrer">
            <Button className="bg-[#5b5baf] hover:bg-[#6b6bc4] text-white font-extrabold rounded-xl px-8 h-14 text-base">
              <img src="/assets/roobet.png" alt="" className="w-5 h-5 mr-2 object-contain" /> PLAY ON ROOBET
            </Button>
          </a>
        </div>

        {/* promo code bar (in normal flow, centered) */}
        <div className="mt-14 w-full max-w-2xl animate-fade-up" style={{ animationDelay: "0.4s" }}>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-5 bg-[#342b60] border border-[#473c7d] rounded-2xl px-5 py-4">
            <span className="text-[#cfc9e8] font-semibold text-sm md:text-base">Use code</span>
            <button
              onClick={copyCode}
              className="flex items-center gap-2 bg-[#251e44] border border-[#5b5baf] rounded-lg px-4 py-2 font-extrabold tracking-wider text-[#edbb23] hover:border-[#edbb23] transition-colors"
            >
              {REF_CODE}
              {copied ? <Check size={16} className="text-green-400" /> : <Copy size={16} />}
            </button>
            <span className="text-[#cfc9e8] font-semibold text-sm md:text-base">to start earning rewards!</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
